import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useForm } from "react-hook-form";
import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { ValidationContext } from "../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import { Token } from "../theme";

interface IButton {
  label: string;
  color?: string;
  onClick: () => void;
}

interface AlertProps {
  /**
   * Title of the alert
   */
  title: string;
  /**
   * Body/Content of the alert
   */
  message: string;
  /**
   * Confirm button label
   */
  confirmLabel: string;
  /**
   * Cancel button label
   */
  cancelLabel: string;
  /**
   * Extra buttons (optional)
   */
  extraButtons?: IButton[];
  /**
   * Function used to add content inside a form
   */
  renderContent?: (register: any, errors: any, control: any) => JSX.Element;
  /**
   * Function to be called when the confirm button is clicked
   */
  onConfirm: (data?: any) => void;
  /**
   * Function to be called when the cancel button is clicked
   */
  onCancel: (data?: any) => void;
  /**
   * Callback fired when the component requests to be closed.
   */
  onClose: () => void;
}

const useStyles = makeStyles(
  (theme: Theme) =>
    createStyles({
      root: {
        "& .MuiTextField-root": {
          margin: theme.spacing(1),
          width: "100%",
        },
      },
    }),
  { index: 1 },
);

export default function AlertComponent(props: AlertProps) {
  const classes = useStyles();

  const renderForm = () =>
    props.renderContent ? (
      <form autoComplete="off" className={classes.root}>
        {/* @ts-ignore */}
        <ValidationContext.Provider value={{ register, errors, control }}>
          {props.renderContent(register, errors, control)}
        </ValidationContext.Provider>
      </form>
    ) : null;

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();

  const onSubmitConfirm = (data: any) => {
    props.onConfirm(data);
  };

  const onSubmitCancel = (data: any) => {
    props.onCancel(data);
  };

  return (
    <>
      <Dialog open={true} onClose={props.onClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
        <DialogTitle id="alert-dialog-title" style={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}>
          {props.title}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description" style={{ marginTop: 10 }}>
            {props.message}
          </DialogContentText>
          {renderForm()}
        </DialogContent>
        <DialogActions>
          {props.extraButtons?.map((extraButton) => (
            <Button style={{ color: extraButton.color || "orange" }} onClick={extraButton.onClick}>
              {extraButton.label}
            </Button>
          ))}
          <Button style={{ color: "black" }} onClick={props.renderContent ? handleSubmit(onSubmitCancel) : props.onCancel}>
            {props.cancelLabel}
          </Button>
          <Button style={{ color: "green" }} onClick={props.renderContent ? handleSubmit(onSubmitConfirm) : props.onConfirm} autoFocus>
            {props.confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
